import React from 'react'

import * as S from './styles'

import IProps from './props'

const DoctorSection = ({ title, children }: IProps) => (
  <S.Container>
    <S.Title>{title}</S.Title>
    <S.Content>{children}</S.Content>
  </S.Container>
)

export default DoctorSection
